export enum TEMPLATE {
    BLANK,
    TITLE_SUBTITLE,
    IMAGE,
    TITLE_TEXT_IMAGE,
}
